import {
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild,
} from '@angular/core';
import { buttonSize, buttonVariant } from '@models/button-options.enum';
import { EditorEntityItem } from '@models/editor';
import { CanvasInputMode, CanvasInputModeService } from '@service/canvas/canvas-input-mode.service';
import { ImportImageService } from '@service/canvas/import-image.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-editor-dropdown',
    templateUrl: './editor-dropdown.component.html',
    styleUrls: ['./editor-dropdown.component.css'],
    standalone: false,
})
export class EditorDropdownComponent implements OnInit, OnDestroy {
    readonly BUTTON_SMALL_SIZE = buttonSize.small;
    readonly BUTTON_TEXT = buttonVariant.text;

    @Input() items!: EditorEntityItem[];
    @Input() translatePrefix!: string;
    @Input() title!: string;
    @Input() icon!: string;

    @Output() onSelectedItem = new EventEmitter();

    @ViewChild('listContainer') listContainer: ElementRef;
    @ViewChild('imagefile') imagefile;
    @ViewChild('svgFile') svgFile;

    selectedItem: any;
    selectedStatus: boolean = false;
    dropdownOpen: boolean = false;

    private destroySubscriptionSubject$ = new Subject<void>();

    constructor(
        private canvasModeService: CanvasInputModeService,
        private importImageService: ImportImageService
    ) {}

    @HostListener('document:click', ['$event'])
    clickOut(event: any) {
        if (this.listContainer?.nativeElement.contains(event.target)) {
            this.dropdownOpen = !this.dropdownOpen;
        } else if (!this.listContainer?.nativeElement.contains(event.target) && this.dropdownOpen) {
            this.dropdownOpen = false;
        }
    }

    ngOnInit(): void {
        this.canvasModeService
            .onModeChanged()
            .pipe(takeUntil(this.destroySubscriptionSubject$))
            .subscribe(mode => {
                const index = this.items.findIndex(item => item.name === mode);
                this.selectedStatus = index !== -1 ? true : false;
                this.selectedItem = this.items[index] ? this.items[index] : undefined;
            });
    }

    ngOnDestroy(): void {
        this.destroySubscriptionSubject$.next();
        this.destroySubscriptionSubject$.complete();
    }

    itemClick(event: MouseEvent, index: number) {
        this.selectedItem = this.items[index];
        if (this.selectedItem?.name === CanvasInputMode.IMAGE) {
            if (this.imagefile) {
                this.imagefile.nativeElement.click();
            }
            return;
        } else if (this.selectedItem?.name === CanvasInputMode.ADD_SVG) {
            if (this.svgFile) {
                this.svgFile.nativeElement.click();
            }
            return;
        }
        this.onSelectedItem.emit(this.selectedItem);
    }

    onSetImage(event) {
        this.dropdownOpen = false;
        this.importImageService.onSetImage(event);
        this.imagefile.nativeElement.value = '';
    }

    onSetSvg(event) {
        this.dropdownOpen = false;
        this.importImageService.onSetSvg(event);
        this.svgFile.nativeElement.value = '';
    }
}
